// extracted by mini-css-extract-plugin
export var sliderRange = "_oa-2";
export var sliderRoot = "_oa-0";
export var sliderThumb = "_oa-3";
export var sliderTrack = "_oa-1";